import { Component } from "preact";
import { DotScale } from "styled-loaders";

const translationStatusLV = {
  BERTHED: "Ostā",
  EXPECTED: "Plānots",
  MOVING: "Kustībā",
  RAID: "Reidā",
};

const translationStateRU = {
  BERTHED: "В ПОРТУ ",
  EXPECTED: "ОЖИДАЕТСЯ",
  MOVING: "В ДВИЖЕНИЕ",
  RAID: "В РЕЙД",
};

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ship: null,
      loaded: false,
      agentImage: "",
      onMap: false,
    };
    this.checkIfEscapePressed = this.checkIfEscapePressed.bind(this);
  }

  /**
   * Returns image url with ship id as string
   *
   * @param {number} id -ship ID
   * @returns {string} image url
   */
  getImageLink = (id) => {
    return "https://oks.rop.lv/api/v1/ships/" + id + "/image";
  };

  /**
   * Returns ship API call url with given ship ID
   *
   * @param {number} id - ship ID
   * @returns {string} API call url
   */
  getShipLink = (id) => {
    return "https://oks.rop.lv/api/v1/getShipForRop/" + id;
  };

  /**
   * Returns url for ship coordinate API
   *
   * @returns {string} coordinate API url
   */
  getMapCordsLink = () => {
    return "https://oks.rop.lv/api/v1/getShipCoords";
  };

  /**
   * Returns path to stored agent image
   *
   * @param {number} regNr - agent registration number
   * @returns {string} path to agent image
   */
  getAgentLink = (regNr) => {
    return "/agent/" + regNr + "/image";
  };

  /**
   * Fetches ship data
   *
   * @param {number} id - ship ID
   */
  getShipData = (id) => {
    fetch(this.getShipLink(id))
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            ship: result,
            loaded: ++this.state.loaded,
          });

          this.getAgentImage(result.shipAgent.regNr);
        },
        (error) => {
          console.log("Kļūda");
        }
      );
  };

  /**
   * Sets received image path as state
   *
   * @param {number} regNr - agent registration number
   */
  getAgentImage = (regNr) => {
    fetch(this.getAgentLink(regNr))
      .then((res) => res.json())
      .then(
        (result) =>
          this.setState({
            agentImage: result.data,
            loaded: ++this.state.loaded,
          }),
        (error) => {
          console.log("Kļūda aģenta attēla iegūšanā!");
          this.setState({ loaded: ++this.state.loaded });
        }
      );
  };

  /**
   * Checks if ship is on map
   *
   * @param {number} visitId - visit ID of ship
   */
  checkIfOnMap = (visitId) => {
    fetch(this.getMapCordsLink())
      .then((res) => res.json())
      .then(
        (result) => {
          if (
            result.find((ship) => {
              return ship.id == visitId;
            })
          ) {
            this.setState({ onMap: true });
          }
        },
        (error) => {
          console.log("Kļūda");
        }
      );
  };

  /**
   * Closes modal if user clicks outside of modal window
   *
   * @param {event} event
   */
  checkIfModalClose = (event) => {
    if (event.target.classList.contains("ships-in-port-modal-background")) {
      this.props.closeModal();
    }
  };

  /**
   * Closes modal if user presses "escape" key
   *
   * @param {event} event
   */
  checkIfEscapePressed = (event) => {
    if (event.key === "Escape") {
      this.props.closeModal();
    }
  };

  componentDidMount = () => {
    document.addEventListener("keydown", this.checkIfEscapePressed, false);
    if (!this.state.ship) {
      this.getShipData(this.props.modalShip.shipVisitId);
    }
    this.checkIfOnMap(this.props.modalShip.shipVisitId);
  };

  /**
   * Translates section titles to given language
   *
   * @param {string} string - string of section in modal window
   * @returns {string} appropriate translation
   */
  translateString = (string) => {
    switch (string) {
      case "Kuģa aģents":
        if (this.props.language == "ru") {
          return "Cудовой агент";
        } else if (this.props.language == "en") {
          return "Ship agent";
        } else {
          return "Kuģa aģents";
        }

      case "Atrašanās Rīgas Ostā":
        if (this.props.language == "ru") {
          return "Посещение порта";
        } else if (this.props.language == "en") {
          return "Port visits";
        } else {
          return "Atrašanās Rīgas ostā";
        }

      case "Informācija par kuģi":
        if (this.props.language == "ru") {
          return "Информация о корабле";
        } else if (this.props.language == "en") {
          return "Information about the ship";
        } else {
          return "Informācija par kuģi";
        }
    }
  };

  /**
   * Creates renderable list of berth visits
   */
  renderBerthVisits = () => {
    let existsBerthvisit = this.state.ship.berthVisits?.some((visit) => {
      if (visit.status != "PLANNED") {
        return true;
      }
    });

    return (
      <>
        <div class="sipl-container" style="height: 207px; overflow-y: scroll;">
          {existsBerthvisit && (
            <h1>{this.translateString("Atrašanās Rīgas Ostā")}</h1>
          )}
          {this.state.ship.berthVisits?.reverse().map((visit, i) => {
            if (visit.status != "PLANNED" && i < 2) {
              return (
                <>
                  <div
                    class="ships-in-port-location"
                  >
                    <div>
                      {new Date(visit.ata.replace(/-/g, "/")).toLocaleString(
                        "lv-LV",
                        {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )}
                    </div>
                    <div class="terminal-owner-div">
                      <div class="anchor-image-wrapper">
                        <img src="/img/anchor_ships.svg" />
                      </div>
                      <span>
                        {!visit.owningCompany || visit.owningCompany == "-"
                          ? null
                          : visit.owningCompany}
                      </span>
                    </div>
                  </div>
                </>
              );
            }
          })}
        </div>
      </>
    );
  };

  /**
   * Rendering content of modal window
   */
  renderContent = () => {
    if (this.state.loaded == 2) {
      return (
        <>
          <header>
            <div>
              <h1>{this.props.modalShip.nosaukums}</h1>
              <span>
                {this.props.language === "lv"
                  ? translationStatusLV[this.props.modalShip.Statuss]
                  : this.props.language === "en"
                  ? this.props.modalShip.Statuss
                  : translationStateRU[this.props.modalShip.Statuss]}
              </span>
            </div>
            <img
              src="/themes/custom/rop/css/img/close.svg"
              onClick={this.props.closeModal}
            />
          </header>
          <section class="ships-in-port-card-main">
            <div class="ships-in-port-card-left">
              {/* Conditional renderin of map */}
              {this.state.onMap ? (
                <iframe
                  src={`https://www.rop.lv/map/?ship=${this.props.modalShip.shipVisitId}`}
                  border="0"
                  style="width:100%; height:200px; margin-bottom: 4px; border: none;"
                />
              ) : null}
              <div class="ship-image-div">
                <img
                  class="ships-in-port-modal-image"
                  alt=""
                  src={
                    this.props.modalShip.FailaId
                      ? this.getImageLink(this.props.modalShip.id)
                      : this.props.modalShip.marineTrafficUrl
                      ? this.props.modalShip.marineTrafficUrl
                      : "/img/ships/placeholder.jpg"
                  }
                />
              </div>
              <div class="ships-in-port-card-map"></div>
            </div>
            <div class="ships-in-port-card-right">
              <h1>{this.translateString("Kuģa aģents")}</h1>
              <a
                class="ships-in-port-card-agent-button"
                href={"/agent/" + this.state.ship.shipAgent.regNr}
              >
                <div>
                  <img src={this.state.agentImage} />
                  <span>{this.state.ship.shipAgent.name}</span>
                  <img class="ships-in-port-agent-icon" />
                </div>
              </a>
              {this.renderBerthVisits()}
              <hr />
              <h1>{this.translateString("Informācija par kuģi")}</h1>
              <table class="ships-in-port-information">
                <tr>
                  <td>IMO</td>
                  <td>
                    <a>{this.state.ship.ship.imo}</a>
                  </td>
                </tr>
                <tr>
                  <td>Vessel Type</td>
                  <td>{this.state.ship.ship.type}</td>
                </tr>
                <tr>
                  <td>Draught</td>
                  <td>{this.state.ship.ship.draught + " m"}</td>
                </tr>
                <tr>
                  <td>Deadweight</td>
                  <td>
                    {parseInt(this.state.ship.ship.deadweight)
                      .toLocaleString()
                      .replace(",", " ") + " t"}
                  </td>
                </tr>
                {this.state.ship.ship.gt && (
                  <tr>
                    <td>Grosston-age</td>
                    <td>{this.state.ship.ship.gt}</td>
                  </tr>
                )}
                {this.state.ship.ship.length && (
                  <tr>
                    <td>Vessel Length</td>
                    <td>{this.state.ship.ship.length + " m"}</td>
                  </tr>
                )}
                {this.state.ship.ship.breadth && (
                  <tr>
                    <td>Breadth</td>
                    <td>{this.state.ship.ship.breadth + " m"}</td>
                  </tr>
                )}
                {this.state.ship.ship.enginePower && (
                  <tr>
                    <td>Engine Power</td>
                    <td>
                      {parseInt(this.state.ship.ship.enginePower) + " kW"}
                    </td>
                  </tr>
                )}
                {this.state.ship.ship.yearBuilt && (
                  <tr>
                    <td>Year build</td>
                    <td>
                      {new Date(
                        this.state.ship.ship.yearBuilt.replace(/-/g, "/")
                      ).getFullYear()}
                    </td>
                  </tr>
                )}
                {this.state.ship._fromPort?.name && (
                  <tr>
                    <td>Previous port</td>
                    <td>{this.state.ship._fromPort?.name}</td>
                  </tr>
                )}
                {this.state.ship.purposes[0] && (
                  <tr>
                    <td>Purpose of visit</td>
                    <td>{this.state.ship.purposes[0]}</td>
                  </tr>
                )}
                {this.state.ship.previousVisit && (
                  <tr>
                    <td>Previous visit</td>
                    <td>
                      {new Date(
                        this.state.ship.previousVisit.replace(/-/g, "/")
                      ).toLocaleString("lv-LV", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>
                  </tr>
                )}
                {this.state.ship.ata ? (
                  <tr>
                    <td>ATA</td>
                    <td>
                      {this.state.ship.ata
                        ? new Date(
                            this.state.ship.ata.replace(/-/g, "/")
                          ).toLocaleString("lv-LV", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        : "-"}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td>ETA</td>
                    <td>
                      {this.state.ship.eta
                        ? new Date(
                            this.state.ship.eta.replace(/-/g, "/")
                          ).toLocaleString("lv-LV", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        : "-"}
                    </td>
                  </tr>
                )}
                <tr>
                  <td>ETD</td>
                  <td>
                    {this.state.ship.etd
                      ? new Date(
                          this.state.ship.etd.replace(/-/g, "/")
                        ).toLocaleString("lv-LV", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "-"}
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </>
      );
    } else {
      return <DotScale color="#063b59" />;
    }
  };

  render() {
    if (this.props.modalVisible) {
      return (
        <div
          class="ships-in-port-modal-background"
          onClick={this.checkIfModalClose}
        >
          <div class="ship-in-port-card">{this.renderContent()}</div>
        </div>
      );
    }
    return;
  }
}
